<div class="container">
    <div tabindex="0" class="me-landing-page-text">
        <div class="me-landing-page-text__header" [innerHTML]="data.text | storyblokRichtext">
        </div>
    </div>
</div>
